import React from 'react';
import { memberId } from '@trello/session-cookie';
import { AtlassianAccountOnboardingBanner } from 'app/src/components/AtlassianAccountOnboardingBanner';
import { EmailHygieneBanner } from 'app/src/components/EmailHygieneWizard';
import { AtlassianAccountMigrationBanner } from 'app/src/components/AtlassianAccountMigration';

export const Banners = () => {
  return (
    <>
      {/* Don't render the AaOnboardingBanner if the user isn't logged in */
      !!memberId && <AtlassianAccountOnboardingBanner />}
      {!!memberId && <EmailHygieneBanner />}
      {!!memberId && <AtlassianAccountMigrationBanner />}
    </>
  );
};
